import TextFilter from 'components/list/Filters/types/TextFilter';
import React from 'react';

const BookingReservationOrderIdFilter = <TextFilter
    label='filters.components.bookingReservationOrderId.label'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='booking_reservation_order_id'
/>;

export default BookingReservationOrderIdFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/BookingReservationOrderIdFilter.js